export const VERSION_MISMATCH_KEY = 'sapling-version-matcher';

export const doesAppVersionMatch = (versionToCheck) => {
  const appVersion = window?.baseAppConfig?.version;
  // only do a comparison if both version vars are defined
  if (versionToCheck && appVersion) {
    return appVersion === versionToCheck;
  }
  return true;
};

let versionMismatchCalls = 0;
let isRecurredMismatch = false;
const checkForRecurringVersionMismatch = (version) => {
  // need version to be passed in to do this
  // also checking for sessionStorage, in case session storage is disabled
  if (!version || !window.sessionStorage) {
    return;
  }
  if (versionMismatchCalls === 0) {
    isRecurredMismatch = version === window.sessionStorage.getItem(VERSION_MISMATCH_KEY);
  }
  window.sessionStorage.setItem(VERSION_MISMATCH_KEY, version);
  versionMismatchCalls += 1;
};

// used in the version check modal
export const isRecurredVersionMismatch = () => isRecurredMismatch;

export const triggerVersionMismatch = (version) => {
  checkForRecurringVersionMismatch(version);
  window.dispatchEvent(new Event(VERSION_MISMATCH_KEY));
};

const CHUNK_LOAD_ERROR_STRING = 'ChunkLoadError';
const CHUNK_LOAD_ERROR_REGEX = /Loading chunk [\S]+ failed/u;

export const isChunkLoadError = (error) =>
  error.name === CHUNK_LOAD_ERROR_STRING && CHUNK_LOAD_ERROR_REGEX.test(error.message);
